// ================================================
// CLARITY REPORTING — SIDEBAR NAVIGATION
// ================================================

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const icons = {
  dashboard: '▣',
  agency:    '◈',
  reports:   '≡',
  settings:  '⚙',
  logout:    '→'
};

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/');
  }

  const isAgency = ['agency', 'agency_pro'].includes(user?.account_type);

  return (
    <aside className="app-sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <div className="sidebar-logo-text">
          Clarity
          <span>Reporting</span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        <NavLink
          to="/dashboard"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          <span>{icons.dashboard}</span>
          Dashboard
        </NavLink>

        {isAgency && (
          <NavLink
            to="/agency"
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            <span>{icons.agency}</span>
            Clients
          </NavLink>
        )}

        <NavLink
          to="/settings"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          <span>{icons.settings}</span>
          Settings
        </NavLink>
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <div style={{ marginBottom: 12 }}>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, fontWeight: 500 }}>
            {user?.first_name} {user?.last_name}
          </div>
          <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 1 }}>
            {user?.account_type?.replace('_', ' ')}
          </div>
        </div>
        <button
          onClick={handleLogout}
          style={{
            background: 'none',
            border: 'none',
            color: 'rgba(255,255,255,0.4)',
            fontSize: 11,
            letterSpacing: 1,
            textTransform: 'uppercase',
            cursor: 'pointer',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}
        >
          {icons.logout} Log Out
        </button>
      </div>
    </aside>
  );
}
